import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PhoneCountryCodeService } from '../../../form-components/phone-country-code/phone-country-code.service';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ReviewPhoneCountryCodeDropdownInputComponent } from './review-phone-country-code-dropdown-input/review-phone-country-code-dropdown-input.component';
import { ReviewPhoneCountryCodeNumberInputComponent } from './review-phone-country-code-number-input/review-phone-country-code-number-input.component';
import { PhoneDropdownItem } from '../../../../../../models/shared/phone-dropdown-item';

@Component({
  selector: 'app-review-phone-country-code',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    ReviewPhoneCountryCodeDropdownInputComponent,
    ReviewPhoneCountryCodeNumberInputComponent
  ],
  templateUrl: './review-phone-country-code.component.html',
  styleUrls: ['./review-phone-country-code.component.scss'],
  providers: [PhoneCountryCodeService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewPhoneCountryCodeComponent {
  @Input() formGroup!: FormGroup;
  @Input() phoneNumberControlName!: string;
  @Input() countryCodeControlName!: string;
  @Input() countryCodes: PhoneDropdownItem[] = [];
  @Input() error: boolean = false;
  @Input() controlId: string = '';
}
